// extracted by mini-css-extract-plugin
export default {"main":"PLinkCont_main__ZyFv4","content":"PLinkCont_content__LikO+","title":"PLinkCont_title__dfeVI","itemCont":"PLinkCont_itemCont__Wo-6x"};